function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsMetric from '@domain-group/fe-allhomes-library/lib/enums/analytics-metric';
import gaHelper from '@domain-group/fe-allhomes-library/lib/utils/ga-helper';
import { allhomesAnalyticsEnabled } from '@domain-group/fe-co-allhomes-analytics';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { VIEWS } from '../proptypes/view';
import { GAActions, GALabels } from '../analytics/constants';
import { jsx as ___EmotionJSX } from "@emotion/core";
var dataLayerSubcategoryOne = 'Browse Results';
var allhomesAnalyticsWrapper = BaseComponent => {
  class AllhomesAnalyticsWrapper extends React.Component {
    constructor(props) {
      super(props);
      _defineProperty(this, "onMapViewClick", () => {
        gaHelper.interactionEvent(GAActions.MAP_VIEW, GALabels.MAP_VIEW);
        this.props.onMapViewClick();
      });
      _defineProperty(this, "onViewSoldClick", () => {
        gaHelper.interactionEvent(GAActions.VIEW_SOLD, GALabels.VIEW_SOLD);
        this.props.onViewSoldClick();
      });
      _defineProperty(this, "onPropertyAlertClick", () => {
        gaHelper.membershipEvent(GAActions.CREATE_PROPERTY_ALERT, GALabels.CREATE_PROPERTY_ALERT);
        this.props.onPropertyAlertClick();
      });
      _defineProperty(this, "onLocationEntryClick", () => {
        if (!this.state.isLocationBoxClicked) {
          this.setState({
            isLocationBoxClicked: true
          });
          gaHelper.interactionEvent(GAActions.LOCATION_ENTRY, GALabels.LOCATION_ENTRY);
          this.props.onLocationEntryClick();
        }
      });
      _defineProperty(this, "onPerformSearch", query => {
        gaHelper.virtualPageView(window.digitalData);
        this.props.sendEvent('view-search-result-page');
        this.props.onPerformSearch(query);
      });
      _defineProperty(this, "onToggleView", type => {
        if (isEqual(type, VIEWS.LIST)) {
          gaHelper.interactionEvent(GAActions.TOGGLE_LIST_VIEW);
        } else if (isEqual(type, VIEWS.MAP)) {
          gaHelper.interactionEvent(GAActions.TOGGLE_MAP_VIEW);
        }
        this.props.onToggleView(type);
      });
      _defineProperty(this, "onMapZoom", () => {
        gaHelper.interactionEvent(GAActions.MAP_INTERACTION, GALabels.MAP_ZOOM);
        this.props.onMapZoom();
      });
      _defineProperty(this, "onMapMove", () => {
        gaHelper.interactionEvent(GAActions.MAP_INTERACTION, GALabels.MAP_MOVE);
        this.props.onMapMove();
      });
      _defineProperty(this, "onMarkerClick", evt => {
        gaHelper.interactionEvent(GAActions.MAP_INTERACTION, GALabels.PIN_CLICK);
        this.props.onMarkerClick(evt);
      });
      _defineProperty(this, "onAdvancedMappingClick", () => {
        gaHelper.interactionEvent(GAActions.MAP_INTERACTION, GALabels.ADVANCED_MAPPING_CLICK);
        this.props.onAdvancedMappingClick();
      });
      _defineProperty(this, "onAddToWatchlistForListView", () => {
        gaHelper.membershipEvent(GAActions.ADD_TO_WATCHLIST, dataLayerSubcategoryOne);
        this.props.onAddToWatchlistForListView();
      });
      _defineProperty(this, "onAddToWatchlistForMapView", () => {
        gaHelper.interactionEvent(GAActions.MAP_INTERACTION, GALabels.WATCHLIST_MAP_CARD);
        this.props.onAddToWatchlistForMapView();
      });
      _defineProperty(this, "fireFeaturedPropertyMetric", listingId => {
        this.context.ahAnalytics.fireListingMetric(listingId, AnalyticsMetric.FEATURED_PROPERTY_IMPRESSION.metricKey);
      });
      _defineProperty(this, "onAlertClick", () => {
        gaHelper.interactionEvent(GAActions.ALERT_ACTION, GALabels.ALERT_CLICK);
      });
      _defineProperty(this, "onCreateAlert", () => {
        gaHelper.interactionEvent(GAActions.ALERT_ACTION, GALabels.CREATE_ALERT);
      });
      _defineProperty(this, "onManageAlert", () => {
        gaHelper.interactionEvent(GAActions.ALERT_ACTION, GALabels.MANAGE_ALERT);
      });
      _defineProperty(this, "onEditAlert", () => {
        gaHelper.interactionEvent(GAActions.ALERT_ACTION, GALabels.EDIT_ALERT);
      });
      _defineProperty(this, "onRemoveAlert", () => {
        gaHelper.interactionEvent(GAActions.ALERT_ACTION, GALabels.REMOVE_ALERT);
      });
      this.state = {
        isLocationBoxClicked: false
      };
    }
    componentDidMount() {
      if (!isEmpty(this.props.featuredProperties)) {
        this.props.featuredProperties.forEach(object => {
          this.fireFeaturedPropertyMetric(object.listing.id);
        });
      }
    }
    render() {
      var props = _objectSpread(_objectSpread({}, this.props), {}, {
        onPropertyAlertClick: this.onPropertyAlertClick,
        onMapViewClick: this.onMapViewClick,
        onViewSoldClick: this.onViewSoldClick,
        onLocationEntryClick: this.onLocationEntryClick,
        onPerformSearch: this.onPerformSearch,
        onToggleView: this.onToggleView,
        onMapZoom: this.onMapZoom,
        onMapMove: this.onMapMove,
        onMarkerClick: this.onMarkerClick,
        onAdvancedMappingClick: this.onAdvancedMappingClick,
        onAddToWatchlistForMapView: this.onAddToWatchlistForMapView,
        onAddToWatchlistForListView: this.onAddToWatchlistForListView,
        onAlertClick: this.onAlertClick,
        onCreateAlert: this.onCreateAlert,
        onManageAlert: this.onManageAlert,
        onEditAlert: this.onEditAlert,
        onRemoveAlert: this.onRemoveAlert
      });
      return ___EmotionJSX(BaseComponent, props);
    }
  }
  AllhomesAnalyticsWrapper.propTypes = {
    onMapViewClick: PropTypes.func,
    onViewSoldClick: PropTypes.func,
    onLocationEntryClick: PropTypes.func,
    onPerformSearch: PropTypes.func,
    onPropertyAlertClick: PropTypes.func,
    onToggleView: PropTypes.func,
    onMapZoom: PropTypes.func,
    onMapMove: PropTypes.func,
    onMarkerClick: PropTypes.func,
    onAdvancedMappingClick: PropTypes.func,
    featuredProperties: PropTypes.array,
    // eslint-disable-line react/forbid-prop-types
    onAddToWatchlistForListView: PropTypes.func,
    onAddToWatchlistForMapView: PropTypes.func,
    onAlertClick: PropTypes.func,
    onCreateAlert: PropTypes.func,
    onManageAlert: PropTypes.func,
    onEditAlert: PropTypes.func,
    onRemoveAlert: PropTypes.func,
    sendEvent: PropTypes.func
  };
  AllhomesAnalyticsWrapper.defaultProps = {
    onAddToWatchlistForListView: () => {},
    onMapViewClick: () => {},
    onViewSoldClick: () => {},
    onLocationEntryClick: () => {},
    onPerformSearch: () => {},
    onPropertyAlertClick: () => {},
    onToggleView: () => {},
    onMapZoom: () => {},
    onMapMove: () => {},
    onMarkerClick: () => {},
    onAdvancedMappingClick: () => {},
    featuredProperties: [],
    onAddToWatchlistForMapView: () => {},
    onAlertClick: () => {},
    onCreateAlert: () => {},
    onManageAlert: () => {},
    onEditAlert: () => {},
    onRemoveAlert: () => {},
    sendEvent: () => {}
  };
  AllhomesAnalyticsWrapper.contextTypes = {
    ahAnalytics: PropTypes.shape({
      fireMetric: PropTypes.func,
      fireListingMetric: PropTypes.func
    })
  };
  return allhomesAnalyticsEnabled(AllhomesAnalyticsWrapper);
};
export default allhomesAnalyticsWrapper;